import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { onClickDeleteSaqData } from "../../modules/actions/index";

class DeleteConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {};
  }

  onClickDelete = () => {
    this.props.onClickDeleteSaqData({
      saqId: this.props.deletedId,
      history: this.props.history,
    });

    this.props.onCloseModal();
  };

  render() {
    const { showModal, onCloseModal } = this.props;

    return (
      <div id="deleteConfirmationModal" className={showModal ? "show" : "hide"}>
        <div className="modal-backdrop"></div>
        <div className="modal-container sm">
          <div className="modal-header">
            <h4>DELETE CONFIRMATION</h4>
          </div>
          <div className="modal-body">
            <p>Are you sure want to delete this record?</p>
          </div>
          <div className="modal-footer">
            <button
              className="button warning btn-cancel"
              onClick={() => onCloseModal()}
            >
              Cancel
            </button>
            <button
              className="button primary btn"
              onClick={() => this.onClickDelete()}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClickDeleteSaqData,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteConfirmationModal);
